import React from 'react';
import { parseImageData } from '../helpers';
import TextDiff from '../diffs/TextDiff';
import { AttachmentKindEnum } from '@koob/enums';

export default function AttachmentDisplay({
  attachment,
  isNew = false,
  isModified = false,
  isRemoved = false,
  beforeKind,
  resolvedAttachment,
}) {
  const kind = attachment.kind ?? AttachmentKindEnum.SECONDARY;
  const translation = attachment.translations?.[0];
  const imageMetadata = parseImageData(attachment.imageData);
  const displayName =
    resolvedAttachment?.displayName ||
    translation?.displayName ||
    imageMetadata?.filename ||
    'Attachment';
  const imageUrl = resolvedAttachment?.imageUrl;

  const kindChanged = isModified && beforeKind !== kind;

  const borderClass = isRemoved
    ? 'border-red-300'
    : isModified
      ? 'border-amber-300'
      : isNew
        ? 'border-green-300'
        : 'border-gray-200';

  return (
    <div
      className={`flex items-center gap-3 p-2 bg-gray-50 rounded border overflow-hidden ${borderClass}`}
    >
      <div className="w-10 h-10 bg-gray-200 rounded flex items-center justify-center shrink-0 overflow-hidden">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={displayName}
            className="w-full h-full object-cover"
          />
        ) : (
          <i className="fa-regular fa-image text-gray-400" />
        )}
      </div>
      <div className="max-w-64 flex-1 min-w-0">
        <div className="text-sm font-medium text-gray-700 truncate">
          {displayName}
        </div>
        {kindChanged ? (
          <TextDiff
            beforeValue={beforeKind ?? AttachmentKindEnum.SECONDARY}
            afterValue={kind}
          />
        ) : (
          <div className="text-xs text-gray-500 capitalize">{kind}</div>
        )}
        {attachment.translations?.length > 1 && (
          <div className="text-xs text-gray-400 mt-1">
            {attachment.translations.map((t) => t.locale).join(', ')}
          </div>
        )}
      </div>
    </div>
  );
}
